import React, { useState } from "react";
import api from "../api";

// For when two players marked each other's card by mistake at the tee —
// swaps every hole either of them has entered so far. Backend refuses if
// either player's card has already been HCP-verified.
export default function SwapCardsButton({ players, eventId, onSwapped }) {
  const [open, setOpen] = useState(false);
  const [playerA, setPlayerA] = useState("");
  const [playerB, setPlayerB] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  if (!players || players.length < 2 || !eventId) return null;

  const close = () => { setOpen(false); setPlayerA(""); setPlayerB(""); setErr(""); };

  const doSwap = async () => {
    if (!playerA || !playerB || playerA === playerB) { setErr("Pick two different players"); return; }
    setBusy(true); setErr("");
    try {
      await api.post("/scores/swap-cards", {
        event_id: eventId,
        player_a_id: parseInt(playerA),
        player_b_id: parseInt(playerB),
      });
      close();
      if (onSwapped) onSwapped();
    } catch (e) {
      setErr(e.response?.data?.error || "Swap failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="bg-orange-600 hover:bg-orange-700 text-white text-xs font-semibold px-3 py-1.5 rounded"
        title="Fix two players' scores if their cards got mixed up at the tee"
      >
        🔄 Swap Cards
      </button>
      {open && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" onClick={close}>
          <div className="bg-white rounded-lg p-5 w-80 shadow-xl" onClick={e => e.stopPropagation()}>
            <div className="font-bold text-gray-800 mb-1">Swap Scorecards</div>
            <div className="text-xs text-gray-500 mb-3">If two players marked each other's card by mistake, this swaps every hole they've entered so far between them.</div>
            <select value={playerA} onChange={e => setPlayerA(e.target.value)} className="border border-gray-300 rounded px-2 py-1.5 text-sm w-full mb-2">
              <option value="">Player A...</option>
              {players.map(p => <option key={p.player_id} value={p.player_id}>{p.name}</option>)}
            </select>
            <select value={playerB} onChange={e => setPlayerB(e.target.value)} className="border border-gray-300 rounded px-2 py-1.5 text-sm w-full mb-2">
              <option value="">Player B...</option>
              {players.map(p => <option key={p.player_id} value={p.player_id}>{p.name}</option>)}
            </select>
            {err && <div className="text-red-600 text-xs mb-2">{err}</div>}
            <div className="flex gap-2 justify-end mt-2">
              <button onClick={close} className="text-xs text-gray-600 px-3 py-1.5">Cancel</button>
              <button onClick={doSwap} disabled={busy} className="bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-white text-xs font-semibold px-3 py-1.5 rounded">
                {busy ? "Swapping..." : "Swap"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
